import { WEBSITE_DETAILS } from "@/config";

const Logo = ({ className = "" }) => {
    return (
        <div className={`inline-flex flex-col items-center ${className}`}>
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-xl font-extrabold text-transparent uppercase">
                {WEBSITE_DETAILS.name}
            </span>
            <div className="flex items-center gap-1">
                <span className="h-[1px] w-3 bg-slate-600"></span>
                <span className="text-[0.65rem] uppercase text-slate-600 font-medium tracking-widest">
                    {WEBSITE_DETAILS.slogan}
                </span>
                <span className="h-[1px] w-3 bg-slate-600"></span>
            </div>
        </div>
    );
};

export default Logo;
